import { render, staticRenderFns } from "./logo-verde-sys.vue?vue&type=template&id=0222e636&"
import script from "./logo-verde-sys.vue?vue&type=script&lang=js&"
export * from "./logo-verde-sys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports